var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb')], 1)]), _c('b-card', [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v("會員管理")]), _c('div', {
    staticClass: "row mx-0 justify-content-between mb-2 mt-4"
  }, [_c('div', [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle",
      value: ['collapse-filter', 'collapse-search'],
      expression: "['collapse-filter', 'collapse-search']"
    }],
    attrs: {
      "variant": "outline-info"
    }
  }, [_c('span', {
    staticClass: "mdi mdi-magnify"
  }), _vm._v("進階搜尋")])], 1), _c('div', [_vm.$permissions.has(_vm.$permissions.consts.CUSTOMER_LIST_IMPORT) ? _c('router-link', {
    staticClass: "btn flex-shrink-0 mb-2 ml-2 btn-inverse-info",
    staticStyle: {
      "line-height": "20px"
    },
    attrs: {
      "to": {
        name: 'CustomerListImport',
        query: {
          merchant_hashid: _vm.query.merchant_hashid
        }
      },
      "target": "_self"
    }
  }, [_c('span', {
    staticClass: "mdi mdi-cloud-upload"
  }), _vm._v(" 批次上傳 ")]) : _vm._e(), _c('b-dropdown', {
    staticClass: "flex-shrink-0 mb-2 ml-2",
    attrs: {
      "variant": "inverse-info"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('span', {
          staticClass: "mdi mdi-download"
        }), _vm._v(" 資料匯出 ")];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', {
    on: {
      "click": function click($event) {
        return _vm.exportCustomers('excel');
      }
    }
  }, [_vm._v("下載 EXCEL")]), _c('b-dropdown-item', {
    on: {
      "click": function click($event) {
        return _vm.exportCustomers('csv');
      }
    }
  }, [_vm._v("匯出 CSV")])], 1)], 1)]), _c('div', {
    staticClass: "mb-2"
  }, [_c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-filter"
    }
  }, [_c('b-card', [_c('b-form', {
    attrs: {
      "inline": ""
    }
  }, [_c('b-form-group', {
    staticClass: "mr-2",
    attrs: {
      "label": "來源通路"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.merchants.length <= 1
    },
    on: {
      "change": _vm.handleChangeMerchant
    },
    model: {
      value: _vm.query.merchant_hashid,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "merchant_hashid", $$v);
      },
      expression: "query.merchant_hashid"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "是否綁定會員"
    }
  }, [_vm.merchants.length > 1 ? _c('b-form-select', {
    attrs: {
      "options": _vm.bindedOptions,
      "disabled": _vm.query.merchant_hashid === 'cross'
    },
    on: {
      "change": _vm.handleChangeMerchant
    },
    model: {
      value: _vm.query.is_binded,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "is_binded", $$v);
      },
      expression: "query.is_binded"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-search"
    }
  }, [_c('b-card', [_c('b-input-group', {
    staticStyle: {
      "max-width": "500px"
    }
  }, [_c('b-input-group-prepend', [_c('b-form-select', {
    staticClass: "mr-2",
    staticStyle: {
      "min-width": "120px"
    },
    attrs: {
      "options": _vm.searchFieldOptions
    },
    model: {
      value: _vm.query.search_field,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "search_field", $$v);
      },
      expression: "query.search_field"
    }
  })], 1), _c('b-form-input', {
    staticStyle: {
      "height": "38px"
    },
    attrs: {
      "placeholder": _vm.searchPlaceholder
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageReset.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.customers,
      "fields": _vm.fields,
      "busy": _vm.isFetchCustomerList
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(avatar_url)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex align-items-center justify-content-center"
        }, [_c('router-link', {
          attrs: {
            "to": {
              name: 'CustomerDetailView',
              params: {
                customerID: data.item.id
              }
            }
          }
        }, [_c('b-avatar', {
          attrs: {
            "src": data.item.avatar_url,
            "variant": "secondary",
            "size": "2rem"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(name)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'CustomerDetailView',
              params: {
                customerID: data.item.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.hiddenString(data.item.name, 20) || "(無法辨識)") + " ")])];
      }
    }, {
      key: "cell(merchant_types)",
      fn: function fn(data) {
        return [_vm.query.merchant_hashid === 'cross' ? [_c('div', {
          attrs: {
            "id": "".concat(data.item.id, "-tooltip")
          }
        }, [data.item.merchant_type_name ? _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v(_vm._s(data.item.merchant_type_name.name))]) : _vm._e(), _vm._l(data.item.cross_merchants, function (merchant) {
          return _c('div', {
            key: merchant.id
          }, [_c('br'), _c('b-badge', {
            staticClass: "mr-1",
            attrs: {
              "variant": "primary"
            }
          }, [_vm._v(_vm._s(merchant.merchant_type_name))])], 1);
        })], 2), _c('b-popover', {
          attrs: {
            "target": "".concat(data.item.id, "-tooltip"),
            "triggers": "hover focus click"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, [_c('ul', {
          staticClass: "my-0"
        }, [data.item.merchant_type_name ? _c('li', [_vm._v(" " + _vm._s(data.item.merchant_type_name.name) + " ")]) : _vm._e(), _vm._l(data.item.cross_merchants, function (merchant) {
          return _c('div', {
            key: merchant.id
          }, [merchant.merchant_name ? _c('li', [_vm._v(" " + _vm._s(merchant.merchant_name) + " ")]) : _vm._e()]);
        })], 2)])])] : [data.item.merchant_type_name ? _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "variant": "primary",
            "id": "single-merchant-".concat(data.item.id)
          }
        }, [_vm._v(_vm._s(data.item.merchant_type_name.type_name) + " ")]) : _vm._e(), _c('b-popover', {
          attrs: {
            "target": "single-merchant-".concat(data.item.id),
            "triggers": "hover focus click"
          }
        }, [_c('ul', [_c('li', [_vm._v(" " + _vm._s(data.item.merchant_type_name.name) + " ")])])]), data.item.cross_merchants.length ? _c('b-badge', {
          attrs: {
            "variant": "primary",
            "id": "cross-merchants-".concat(data.item.id)
          }
        }, [_vm._v(" 其他通路 ")]) : _vm._e(), _c('b-popover', {
          attrs: {
            "target": "cross-merchants-".concat(data.item.id),
            "triggers": "hover focus click"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, [_c('ul', {
          staticClass: "my-0"
        }, _vm._l(data.item.cross_merchants, function (merchant) {
          return _c('li', {
            key: merchant.id
          }, [_vm._v(" " + _vm._s("".concat(merchant.merchant_type_name, " (").concat(merchant.merchant_name, ")")) + " ")]);
        }), 0)])])]];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "secondary"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "mdi mdi-menu"
        })]), _c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'CustomerDetailView',
              params: {
                customerID: data.item.id
              }
            }
          }
        }, [_vm._v(" 檢視 ")])], 2)];
      }
    }])
  })], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }